<template>
  <div
    ref="columnsBar"
    :class="$.adding_panel"
  >
    <columns-bar-header
      :title="locales('custom_columns_adding_title')"
      :view-config="viewConfig"
      :tabs="tabs"
      :back-button="true"
      :help-button="false"
      @onChangeTab="changeTab"
      @onClose="onClose"
      @backClick="backClick"
    />
    <component
      :is="currentComponent"
      :key="currentComponent"
      :all-columns="allColumns"
      :project-columns-ids="projectColumnsIds"
      :new-column="newColumn"
      @showExistingColumnsByUserValue="showExistingColumnsByUserValue"
      @onReuseExistingColumn="id => $emit('onReuseExistingColumn', id)"
      @redirectToSettings="$emit('redirectToSettings')"
      @showMarkerOnExistingTab="showMarkerOnExistingTab"
      @changeView="(view, tab) => $emit('changeView', view, tab)"
      @setNewColumnData="setNewColumnData"
      @saveNewColumn="saveNewColumn"
    />
  </div>
</template>

<script>
import projectModel from '../../../../models/projects';
import columnsBarHeader from '../components/header/index.vue';
import createColumns from '../components/createColumnTab/createColumnTab.vue';
import existingColumns from '../components/existingTab/existingTab.vue';

export default {
  name: 'ColumnsBarAddingView',
  components: { columnsBarHeader, createColumns, existingColumns },
  props: {
    viewConfig: { type: Object, required: true, default: () => {} },
  },
  emits: {
    onClose: null,
    backClick: null,
    redirectToSettings: null,
    saveNewColumn: Object,
    changeView: String,
  },
  data() {
    return {
      locales: __,
      currentComponent: null,
      newColumn: {},
      tabs: [
        {
          type: 'createColumns',
          title: __('columns_bar_create_columns_tab'),
          width: 125,
        },
        {
          type: 'existingColumns',
          title: __('columns_bar_existing_columns_tab'),
          width: 125,
          marker: false,
        },
      ],
    };
  },
  computed: {
    projectId() {
      return projectModel.getActiveGanttId();
    },
    allColumns() {
      return this.$store.getters['columns/getAllCustomColumns'];
    },
    projectColumnsIds() {
      return this.$store.getters['columns/getColumnIdsByProjectId'](this.projectId);
    },
  },
  watch: {
    viewConfig: {
      handler() {
        this.currentComponent = this.viewConfig.activeTab;
      },
      immediate: true,
    },
    'viewConfig.isArchivedProject': function (flag) {
      if (flag) {
        this.newColumn = {};
        this.$emit('setUserChangesFlag', false);
        this.backClick();
      }
    },
  },
  beforeDestroy() {
    this.newColumn = {};
  },
  created() {},
  methods: {
    changeTab(obj) {
      this.showMarkerOnExistingTab(false);
      this.currentComponent = obj.type;

      if (obj.type === 'existingColumns') {
        userExtAnalytics.log('columns_sidebar_existed_columns_tab');
      } else {
        userExtAnalytics.log('columns_sidebar_new_column_tab');
      }
    },
    onClose() {
      this.$emit('onClose');
    },
    backClick() {
      this.$emit('backClick');
    },
    showExistingColumnsByUserValue() {
      this.showMarkerOnExistingTab(false);
      this.$emit('changeView', null, 'existingColumns');
    },
    setNewColumnData(data) {
      this.newColumn = {
        ...this.newColumn,
        ...data,
      };

      if (this.newColumn.name?.length || this.newColumn.options?.length) {
        this.$emit('setUserChangesFlag', true);
      } else {
        this.$emit('setUserChangesFlag', false);
      }
    },
    showMarkerOnExistingTab(flag) {
      this.tabs[1].marker = flag;
    },
    saveNewColumn() {
      const dataForSave = {
        name: this.newColumn.defaultName,
        type: this.newColumn.type,
        options: [],
      };

      if (this.newColumn.options && this.newColumn.options.length) {
        dataForSave.options = this.newColumn.options;
      }

      if (this.newColumn.name && this.newColumn.name.length) {
        dataForSave.name = this.newColumn.name;
      }

      if (dataForSave.name.length) {
        this.$emit('saveNewColumn', dataForSave);
      }
    },
  },
};
</script>

<style module='$' lang='less'>
.adding_panel {
  background-color: #ffffff;
  box-shadow: -20px 0px 22px -22px rgba(0, 0, 0, 0.2);
}
</style>
